import React from 'react';

export default ({ width = 32, height = 32, fill = '#FFFFFA' }) => {
	return (
		<svg
			width={width}
			height={height}
			viewBox='0 0 512 512'
			preserveAspectRatio='xMidYMid meet'
		>
			<g
				fill={fill}
				stroke={'none'}
				transform={'translate(0,512) scale(0.100000,-0.100000)'}
			>
				<path d='M2380 5109 c-251 -28 -494 -124 -700 -277 -100 -74 -271 -248 -343 -349 -104 -146 -178 -305 -223 -478 -40 -152 -44 -221 -44 -842 l0 -603 -71 0 c-38 0 -91 -5 -117 -12 -106 -25 -205 -124 -230 -230 -17 -67 -17 -2009 0 -2076 25 -106 124 -205 230 -230 67 -17 3289 -17 3356 0 106 25 205 124 230 230 17 67 17 2009 0 2076 -25 106 -124 205 -230 230 -34 9 -385 12 -1287 12 l-1241 0 0 588 c0 478 3 600 15 657 65 307 304 559 612 647 112 32 334 32 446 0 298 -85 530 -322 607 -620 6 -24 15 -92 20 -152 12 -146 39 -198 130 -246 30 -16 58 -19 195 -19 157 0 161 0 208 28 26 15 60 47 75 69 23 36 27 54 31 132 10 275 -89 590 -266 839 -72 101 -243 275 -343 349 -304 224 -672 320 -1060 277z' />
			</g>
		</svg>
	);
};
